import { DefaultRow } from "@pdf/helpers/default-row/default-row";
import { jsPDF } from "jspdf";

export class ReferenceMeasureRow extends DefaultRow {
  readonly number: string[];
  readonly displayName: string[];
  readonly scale: string[];
  readonly unit: string[];
  readonly notes: string[];

  public constructor(pdf: jsPDF, number: string[], displayName: string[], scale: string[], unit: string[], notes: string[]) {
    super();
    this.number = number;
    this.displayName = displayName;
    this.scale = scale;
    this.unit = unit;
    this.notes = notes;
    this._textHeight = this.calculateRowTextHeight(pdf);
    this._rowHeight = this.calculateRowHeight(this.textHeight);
  }
  private calculateRowTextHeight(pdf: jsPDF) {
    return Math.max(
      ...[
        this.calculateCellTextHeight(pdf, this.number),
        this.calculateCellTextHeight(pdf, this.displayName),
        this.calculateCellTextHeight(pdf, this.scale),
        this.calculateCellTextHeight(pdf, this.unit),
        this.calculateCellTextHeight(pdf, this.notes),
      ],
    );
  }
}
